/* Product page behaviour (sections/hj-product.liquid): gallery, color tabs, variant options, quantity,
   Add to Bag, accordions, Make It a Set, Accessorize, reviews. Cart calls go through HJ.cart (assets/hj.js);
   when it is not there the forms post to /cart/add as plain HTML. */
(() => {
  const DASH = '\u2014';

  const money = (cents) => {
    const fmt = (window.HJ && window.HJ.money) || '${{amount}}';
    const n = Math.round(cents) / 100;
    const two = n.toFixed(2);
    const withCommas = (s, sep, dec) => {
      const [a, b] = s.split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (b ? dec + b : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withCommas(Math.round(n).toString(), ',', '.');
      if (k === 'amount_with_comma_separator') return withCommas(two, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withCommas(Math.round(n).toString(), '.', ',');
      return withCommas(two, ',', '.');
    });
  };

  const cartAdd = (items, form) => {
    const cart = window.HJ && window.HJ.cart;
    if (cart && typeof cart.add === 'function') return cart.add(items);
    if (form) form.submit();
    return Promise.resolve();
  };

  /* ---------- product main ---------- */
  const pm = document.querySelector('[data-hj-product]');
  if (pm) {
    const data = JSON.parse(pm.querySelector('[data-hj-product-json]').textContent);
    const salePct = data.salePct || 0;
    let variant = data.variants.find((v) => String(v.id) === pm.querySelector('[data-hj-atc] input[name="id"]').value) || data.variants[0];
    let qty = 1;

    // gallery
    const mainImg = pm.querySelector('.hjpm-media > img');
    const thumbs = [...pm.querySelectorAll('.hjpm-thumb')];
    const status = pm.querySelector('.hjpm-galstatus');
    let index = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
    const show = (i) => {
      if (!thumbs.length || !mainImg) return;
      index = (i + thumbs.length) % thumbs.length;
      const t = thumbs[index];
      mainImg.src = t.dataset.src;
      mainImg.alt = t.dataset.alt || '';
      thumbs.forEach((b, j) => b.setAttribute('aria-current', j === index ? 'true' : 'false'));
      if (status) status.textContent = `Image ${index + 1} of ${thumbs.length}`;
    };
    pm.querySelector('.hjpm-navbtn.is-prev')?.addEventListener('click', () => show(index - 1));
    pm.querySelector('.hjpm-navbtn.is-next')?.addEventListener('click', () => show(index + 1));
    thumbs.forEach((t, j) => t.addEventListener('click', () => show(j)));

    // color tabs: All keeps the live order; a group shows its members, the selected color first when it is not one
    const colors = pm.querySelector('[data-hj-colors]');
    if (colors) {
      const box = colors.querySelector('.hjpm-swatches');
      const items = [...box.children];
      items.forEach((el, i) => { el.dataset.i = i; });
      const tabs = [...colors.querySelectorAll('.hjpm-tab')];
      // Live keeps the tab in the URL (?tab=core, replaced, not pushed; All drops it), opens on it, and the color
      // links carry it to the next product.
      const links = items.map((el) => (el.matches('a[href]') ? el : el.querySelector('a[href]'))).filter(Boolean);
      links.forEach((a) => { a.dataset.href = a.getAttribute('href').replace(/[?&]tab=[^&]*/, ''); });
      const applyTab = (tab, fromUrl) => {
        tabs.forEach((t) => t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'));
        const g = tab.dataset.tab;
        const sel = items.find((el) => el.hasAttribute('data-sel'));
        let list = g === 'all' ? items : items.filter((el) => (el.dataset.groups || '').split(' ').includes(g));
        if (g !== 'all' && sel && !list.includes(sel)) list = [sel, ...list];
        items.forEach((el) => { el.hidden = !list.includes(el); });
        list.forEach((el) => box.appendChild(el));
        items.filter((el) => el.hidden).forEach((el) => box.appendChild(el));
        links.forEach((a) => { const u = new URL(a.dataset.href, location.origin); if (g === 'all') u.searchParams.delete('tab'); else u.searchParams.set('tab', g); a.setAttribute('href', u.pathname + u.search + u.hash); });
        if (!fromUrl) {
          const u = new URL(location.href);
          if (g === 'all') u.searchParams.delete('tab'); else u.searchParams.set('tab', g);
          history.replaceState(history.state, '', u.pathname + u.search + u.hash);
        }
      };
      tabs.forEach((tab) => tab.addEventListener('click', () => applyTab(tab, false)));
      const start = new URLSearchParams(location.search).get('tab');
      const startTab = start && tabs.find((t) => t.dataset.tab === start.toLowerCase());
      if (startTab) applyTab(startTab, true);
    }

    // price, add to bag, express
    const priceOf = (v) => (salePct > 0 ? Math.round((v.price * (100 - salePct)) / 10000) * 100 : v.price);
    const wasOf = (v) => (salePct > 0 ? v.price : v.compare > v.price ? v.compare : 0);
    const atcForm = pm.querySelector('[data-hj-atc]');
    const atc = atcForm.querySelector('.hjpm-atc');
    const render = () => {
      const p = priceOf(variant), w = wasOf(variant);
      const priceEl = pm.querySelector('[data-hj-price]');
      priceEl.textContent = money(p);
      priceEl.classList.toggle('is-sale', w > p);
      let wasEl = pm.querySelector('[data-hj-was]');
      if (w > p) {
        if (!wasEl) { wasEl = document.createElement('span'); wasEl.className = 'hjpm-was'; wasEl.setAttribute('data-hj-was', ''); priceEl.after(wasEl); }
        wasEl.textContent = money(w);
      } else if (wasEl) wasEl.remove();
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? `Add to Bag ${DASH} ${money(p * qty)}` : 'Sold Out';
      pm.querySelectorAll('input[name="id"]').forEach((i) => { i.value = variant.id; });
      pm.querySelectorAll('input[name="quantity"]').forEach((i) => { i.value = qty; });
      const spb = pm.querySelector('shop-pay-button');
      if (spb) spb.setAttribute('variants', `${variant.id}:${qty}`);
      const express = pm.querySelector('[data-hj-express]');
      if (express) express.hidden = !variant.available;
      const stickyBtn = pm.querySelector('.hjpm-sticky-atc');
      if (stickyBtn) stickyBtn.textContent = atc.textContent;
      updateSticky();
    };

    // sticky add bar while the Add to Bag row is out of view
    const sticky = pm.querySelector('[data-hj-sticky]');
    let atcVisible = true;
    const updateSticky = () => { if (sticky) sticky.hidden = atcVisible || !variant.available; };
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => { atcVisible = entries[0].isIntersecting; updateSticky(); }).observe(pm.querySelector('.hjpm-atcrow'));
      sticky.querySelector('form').addEventListener('submit', (e) => {
        if (!(window.HJ && window.HJ.cart)) return;
        e.preventDefault();
        cartAdd([{ id: variant.id, quantity: qty }]);
      });
    }

    // quantity
    const [minus, plus] = pm.querySelectorAll('.hjpm-qtybtn');
    const qtyVal = pm.querySelector('.hjpm-qtyval');
    const setQty = (n) => { qty = Math.max(1, n); qtyVal.textContent = qty; minus.disabled = qty <= 1; render(); };
    minus.addEventListener('click', () => setQty(qty - 1));
    plus.addEventListener('click', () => setQty(qty + 1));

    atcForm.addEventListener('submit', (e) => {
      if (!(window.HJ && window.HJ.cart)) return;
      e.preventDefault();
      if (!variant.available) return;
      atc.setAttribute('aria-busy', 'true');
      Promise.resolve(cartAdd([{ id: variant.id, quantity: qty }])).finally(() => atc.removeAttribute('aria-busy'));
    });

    // variant options (multi-variant products)
    const groups = [...pm.querySelectorAll('[data-hj-option]')];
    if (groups.length) {
      const selected = () => groups.map((g) => {
        const s = g.querySelector('.is-sel');
        return s ? (s.closest('[data-value]') || s).dataset.value : null;
      });
      const markSelected = (g, value) => {
        g.querySelectorAll('[data-value]').forEach((el) => {
          const on = el.dataset.value === value;
          const target = el.classList.contains('hjpm-swwrap') ? el.querySelector('.hjpm-sw') : el;
          target.classList.toggle('is-sel', on);
          if (on) target.setAttribute('aria-current', 'true'); else target.removeAttribute('aria-current');
        });
        const label = g.querySelector('[data-hj-option-label]');
        if (label) label.textContent = value;
      };
      const refreshAvailability = (sel) => {
        groups.forEach((g, gi) => g.querySelectorAll('[data-value]').forEach((el) => {
          const want = sel.slice(); want[gi] = el.dataset.value;
          const v = data.variants.find((x) => x.options.every((o, k) => o === want[k]));
          const ok = !!(v && v.available);
          if (el.classList.contains('hjpm-pill')) el.classList.toggle('is-out', !ok && !el.classList.contains('is-sel'));
          if (el.classList.contains('hjpm-swwrap') && groups.length > 1) el.hidden = !v;
          if (v && el.tagName === 'A') el.setAttribute('href', `${data.url}?variant=${v.id}`);
        }));
      };
      groups.forEach((g, gi) => g.addEventListener('click', (e) => {
        const el = e.target.closest('[data-value]');
        if (!el || !g.contains(el)) return;
        e.preventDefault();
        const sel = selected(); sel[gi] = el.dataset.value;
        let v = data.variants.find((x) => x.options.every((o, k) => o === sel[k]));
        if (!v) v = data.variants.find((x) => x.options[gi] === sel[gi] && x.available) || data.variants.find((x) => x.options[gi] === sel[gi]);
        if (!v) return;
        variant = v;
        groups.forEach((gg, k) => markSelected(gg, v.options[k]));
        refreshAvailability(v.options);
        if (v.image > 0) show(v.image - 1);
        render();
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url);
      }));
    }

    // accordions
    pm.querySelectorAll('.hjpm-acc').forEach((acc) => {
      const head = acc.querySelector('.hjpm-acchead');
      head.addEventListener('click', () => {
        const open = acc.dataset.open !== 'true';
        acc.dataset.open = String(open);
        head.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------- color strips (set + accessorize) ---------- */
  // the live strips scroll the selected color into the middle of the row
  document.querySelectorAll('.sb-cstrip-row').forEach((row) => {
    const sel = row.querySelector('.sb-cstrip-sw.is-sel');
    if (sel && row.scrollWidth > row.clientWidth) row.scrollLeft = sel.offsetLeft - row.offsetLeft - (row.clientWidth - sel.offsetWidth) / 2;
  });
  const strip = (root, onPick) => root.querySelectorAll('.sb-cstrip-row').forEach((row) => row.addEventListener('click', (e) => {
    const b = e.target.closest('.sb-cstrip-sw');
    if (!b || b.disabled) return;
    e.preventDefault();
    row.querySelectorAll('.sb-cstrip-sw').forEach((x) => {
      const on = x === b;
      x.classList.toggle('is-sel', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
    });
    onPick(b, row);
  }));

  /* ---------- Make It a Set ---------- */
  const set = document.querySelector('[data-hj-set]');
  if (set) {
    const cards = [...set.querySelectorAll('.hjms-card')];
    const anchor = set.querySelector('.hjms-card--anchor');
    const check = set.querySelector('.hjms-pill svg')?.outerHTML || '';
    const pctFor = (n) => (n >= 3 ? 15 : n === 2 ? 5 : 0);
    const priceHTML = (cents, pct) => (pct ? `<s class="hjms-price-was">${money(cents)}</s><span class="hjms-price-now">${money(Math.round((cents * (100 - pct)) / 100))}</span>` : money(cents));
    const update = () => {
      const on = cards.filter((c) => c === anchor || c.classList.contains('hjms-card--on'));
      const n = on.length, pct = pctFor(n);
      cards.forEach((c) => { c.querySelector('.hjms-price').innerHTML = priceHTML(+c.dataset.price, pct); });
      const was = on.reduce((s, c) => s + +c.dataset.price, 0);
      const now = on.reduce((s, c) => s + Math.round((+c.dataset.price * (100 - pct)) / 100), 0);
      const top = set.querySelector('.hjms-top');
      let pill = set.querySelector('.hjms-pill');
      if (pct) {
        if (!pill) { pill = document.createElement('p'); pill.className = 'hjms-pill'; top.appendChild(pill); }
        pill.innerHTML = `${check}Save ${money(was - now)}`;
      } else if (pill) pill.remove();
      set.querySelector('.hjms-total-values').innerHTML = pct
        ? `<s class="hjms-total-was">${money(was)}</s><span class="hjms-total-now">${money(now)}</span><span class="hjms-total-saving">Saving ${money(was - now)}</span>`
        : `<span class="hjms-total-now">${money(was)}</span><span class="hjms-total-saving">Add 1 more to save</span>`;
      set.querySelector('.hjms-sr').textContent = `${n} item${n === 1 ? '' : 's'} selected${pct ? `, ${pct}% off` : ''}`;
    };
    // the anchor follows the bottle's variant (multi-variant products)
    cards.forEach((c) => {
      if (c === anchor) return;
      c.querySelector('.hjms-card-box').addEventListener('change', (e) => { c.classList.toggle('hjms-card--on', e.target.checked); update(); });
    });
    strip(set, (b) => {
      const c = b.closest('.hjms-card');
      c.dataset.variant = b.dataset.variant;
      c.dataset.price = b.dataset.price;
      const img = c.querySelector('.hjms-card-media img');
      if (img && b.dataset.image) img.src = b.dataset.image;
      c.querySelector('.hjms-card-variant').textContent = `${c.dataset.type} - ${b.dataset.title}`;
      update();
    });
    set.querySelector('[data-hj-set-form]').addEventListener('submit', (e) => {
      if (!(window.HJ && window.HJ.cart)) return;
      e.preventDefault();
      const pmId = document.querySelector('[data-hj-atc] input[name="id"]');
      if (pmId) anchor.dataset.variant = pmId.value;
      const on = cards.filter((c) => c === anchor || c.classList.contains('hjms-card--on'));
      cartAdd(on.map((c) => ({ id: +c.dataset.variant, quantity: 1, properties: { _MS: String(on.length) } })));
    });
  }

  /* ---------- Accessorize ---------- */
  const acc = document.querySelector('[data-hj-acc]');
  if (acc) {
    strip(acc, (b) => {
      const row = b.closest('.hjac-row');
      row.dataset.variant = b.dataset.variant;
      row.querySelector('input[name="id"]').value = b.dataset.variant;
      row.querySelector('.hjac-meta').textContent = `${money(+b.dataset.price)} · ${b.dataset.title}`;
    });
    acc.querySelectorAll('[data-hj-acc-form]').forEach((f) => f.addEventListener('submit', (e) => {
      if (!(window.HJ && window.HJ.cart)) return;
      e.preventDefault();
      cartAdd([{ id: +f.querySelector('input[name="id"]').value, quantity: 1 }]);
    }));
  }

  /* ---------- Reviews ---------- */
  const rv = document.querySelector('.hj-rv');
  if (rv) {
    const cta = rv.querySelector('.hj-rv-cta');
    const form = rv.querySelector('[data-hj-review-form]');
    cta?.addEventListener('click', () => {
      const open = cta.getAttribute('aria-expanded') !== 'true';
      cta.setAttribute('aria-expanded', String(open));
      if (form) form.hidden = !open;
    });
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const note = form.querySelector('[data-hj-review-note]');
      if (note) note.hidden = false;
    });
    const more = rv.querySelector('[data-hj-reviews-more]');
    const list = rv.querySelector('.hj-rl-cards');
    let all = null, shown = list ? list.children.length : 0;
    const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    const STAR = '<path d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"></path>';
    const stars = (n) => [1, 2, 3, 4, 5].map((i) => `<span style="display:inline-block;width:14px;height:14px;line-height:0;flex:0 0 auto"><svg width="14" height="14" viewBox="0 0 24 24" fill="${i <= n ? 'var(--color-star, var(--color-text, #1A1A1A))' : 'var(--color-border, #E8E6E1)'}" aria-hidden="true" focusable="false" style="display:block">${STAR}</svg></span>`).join('');
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = (iso) => `${MONTHS[+iso.slice(5, 7) - 1]} ${+iso.slice(8, 10)}, ${iso.slice(0, 4)}`;
    const VERIFIED = '<span style="font-family:var(--type-eyebrow-family, \'Inter\', -apple-system, BlinkMacSystemFont, sans-serif);font-size:9px;font-weight:var(--type-eyebrow-weight, 600);line-height:var(--type-eyebrow-line-height, 1.2);letter-spacing:var(--type-eyebrow-letter-spacing, 0.16em);text-transform:var(--type-eyebrow-transform, uppercase);color:var(--color-text, #1A1A1A);border:1px solid var(--color-border, #E8E6E1);border-radius:var(--radius-small, 4px);padding:3px 6px;display:inline-flex;align-items:center;gap:4px"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>Verified</span>';
    const card = (r) => `<article class="hj-rl-card"><div class="hj-rl-top"><span role="img" aria-label="${esc(r.author)} rated this ${r.rating} out of 5 stars" style="display:inline-flex;gap:1px;line-height:0">${stars(r.rating)}</span><time class="hj-rl-date" datetime="${esc(r.date)}">${date(r.date)}</time></div>${r.title ? `<p class="hj-rl-title">${esc(r.title)}</p>` : ''}<p class="hj-rl-body">${esc(r.body)}</p><div class="hj-rl-foot"><span class="hj-rl-name">${esc(r.author)}</span>${r.verified ? VERIFIED : ''}${r.variant ? `<span class="hj-rl-variant"><span class="hj-sr">Colourway reviewed: </span>${esc(r.variant)}</span>` : ''}</div></article>`;
    more?.addEventListener('click', async () => {
      more.setAttribute('aria-busy', 'true');
      try {
        if (!all) all = await (await fetch(rv.dataset.reviewsUrl)).json();
        const next = all.slice(shown, shown + 5);
        list.insertAdjacentHTML('beforeend', next.map(card).join(''));
        shown += next.length;
        if (shown >= all.length) more.parentElement.remove();
      } finally {
        more.setAttribute('aria-busy', 'false');
      }
    });
  }
})();
